import CookieAccept from '@thinktomorrow/cookie-accept';

// Docs: https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/dialog
const initCookieBar = () => ({
    showOptions: false,
    init() {
        document.addEventListener('CookieDoesNotExistOnLoad', () => {
            this.open();
        });

        document.addEventListener('CookieUpdated', () => {
            this.close();
        });

        document.addEventListener('OpenCookieBar', () => {
            this.open();
        });

        window.CookieAccept = new CookieAccept({
            name: 'legal-cookies',
            gtm: { enabled: true },
        });
    },
    open() {
        this.$root.classList.remove('hidden');
    },
    close() {
        this.$root.classList.add('hidden');
    },
});

export { initCookieBar as default };
